/* eslint-disable react/jsx-no-target-blank */

import * as React from 'react';
import classNames from 'classnames';
import styles from './srBadge.module.scss';

const SRBadge: React.FC = () => {
    return (
        <a
            href="https://searchready.cz"
            className={classNames(styles.srBadge)}
            data-testid="searchready-badge"
            target="_blank"
        >
            Powered by <strong>SEARCH READY</strong>
        </a>
    );
};

export default SRBadge;
